import { render } from "./ServiceDetails4Page.vue?vue&type=template&id=bac6854a&ts=true"
import script from "./ServiceDetails4Page.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails4Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__